
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plataforma",
      function () {
        return require("private-next-pages/plataforma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plataforma"])
      });
    }
  